import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useContext } from 'react';

import { usePermissions } from '../../../../api/me.js';
import { PermissionDeniedPage, WebsiteNotFoundPage } from '../../../../components/SectionStates.js';
import { WebsiteStatusContext } from '../../../../components/WebsiteSection.js';

/**
 * The Custom data section: information the assistant may use that isn't on
 * the website (custom pages). It sits next to Knowledge and needs the same
 * knowledge permission (`patterns/ui-patterns.md`, 3).
 */
export const Route = createFileRoute('/_app/websites/$websiteId/custom-data')({
  component: CustomDataLayout,
});

function CustomDataLayout() {
  const permissions = usePermissions();
  const websiteStatus = useContext(WebsiteStatusContext);
  if (!permissions.includes('knowledge')) {
    return <PermissionDeniedPage title="Custom data" permission="knowledge" />;
  }
  if (websiteStatus === 'not-found') return <WebsiteNotFoundPage title="Custom data" />;
  return <Outlet />;
}
